module.exports = __webpack_public_path__ + "assets/img/sanaudos.6f0f929e.jpg";